/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@mui/system';
import { EmbersButton } from '../../../button/button';
var LoadMoreContainer = styled('div')(function () {
  return {
    '&.EmbersTable-LoadMore-root': {
      display: 'flex',
      paddingRight: '30%',
      justifyContent: 'center'
    }
  };
});
export var EmbersTableLoadMore = function EmbersTableLoadMore(props) {
  var onResultsPerPageChange = props.onResultsPerPageChange,
    _props$resultsPerPage = props.resultsPerPage,
    resultsPerPage = _props$resultsPerPage === void 0 ? 10 : _props$resultsPerPage,
    _props$loadMoreStep = props.loadMoreStep,
    loadMoreStep = _props$loadMoreStep === void 0 ? 10 : _props$loadMoreStep,
    pageCount = props.pageCount,
    mixpanelProps = props.mixpanelProps;
  var intl = useIntl();
  if (!pageCount || pageCount === 1) return null;
  var handleClick = function handleClick() {
    var _mixpanelProps$tracke, _mixpanelProps$tracke2;
    var pageIncrement = resultsPerPage + loadMoreStep;
    mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke = (_mixpanelProps$tracke2 = mixpanelProps.tracker).loadMoreData) === null || _mixpanelProps$tracke === void 0 || _mixpanelProps$tracke.call(_mixpanelProps$tracke2, mixpanelProps.tableName, pageIncrement);
    onResultsPerPageChange === null || onResultsPerPageChange === void 0 || onResultsPerPageChange(pageIncrement);
  };
  return /*#__PURE__*/React.createElement(LoadMoreContainer, {
    className: "EmbersTable-LoadMore-root"
  }, /*#__PURE__*/React.createElement(EmbersButton, {
    onClick: handleClick,
    level: "tertiary",
    colorTheme: "purple",
    drawingStyle: "text",
    size: "small"
  }, intl.formatMessage({
    id: 'embers.table.bottomControls.loadMore',
    defaultMessage: 'Load more'
  })));
};